import { useMutation, useQueryClient } from '@tanstack/react-query'
import { deleteDocument } from '@/services/documents/documentsApi'
import { documentsQueryKey } from './useDocuments'

// Uploading from the library is gone: files enter through a chat, where /v2 can
// store the original once and reference it. The library still lists, previews
// and deletes.
export function useDeleteDocument() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (id) => deleteDocument(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: documentsQueryKey() }),
  })
}
